import { render, staticRenderFns } from "./StoreInfoRewards.vue?vue&type=template&id=66b5a65a&scoped=true"
import script from "./StoreInfoRewards.vue?vue&type=script&lang=js"
export * from "./StoreInfoRewards.vue?vue&type=script&lang=js"
import style0 from "./StoreInfoRewards.vue?vue&type=style&index=0&id=66b5a65a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b5a65a",
  null
  
)

export default component.exports